// Catalog of pages a user can favorite on the homepage. Built from the same
// NAV_SECTIONS model that drives the side-nav drawer so names, paths, and
// role gates stay defined in one place (components/Navigation/SideNav.js).
import { NAV_SECTIONS, sectionGroups } from "../Navigation/SideNav";

// Favorites are identified by path, so a page that appears twice in the nav
// would collide here; keep only the first occurrence.
const seen = new Set();

// One catalog section per nav group where a section has groups (so the
// picker keeps fine-grained headings like "Service Requests"), otherwise one
// per section. Coming-soon entries aren't favoritable or widget-capable yet.
export const favoritesCatalog = NAV_SECTIONS.flatMap((section) =>
  sectionGroups(section).map((group) => ({
    label: group.title || section.title,
    items: group.items
      .filter((item) => !item.disabled)
      .filter(({ path }) => !seen.has(path) && seen.add(path))
      .map(({ name, path, roles }) => ({ name, path, roles })),
  }))
).filter((section) => section.items.length > 0);
